import React, { FunctionComponent } from "react";

interface Props {
  className?: string;
}

const Contact: FunctionComponent<Props> = ({ className }) => {
  return (
    <svg
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2 38.5L38.5 2.5M38.5 2.5V26.5M38.5 2.5H14.5"
        stroke="black"
        strokeWidth="5"
      />
    </svg>
  );
};

export default Contact;
